import TokenWidget from '@plone/volto/components/manage/Widgets/TokenWidget';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

/**
 * TagWhitelistWidget component class.
 * Wraps TokenWidget to handle base64-encoded string values
 * @class TagWhitelistWidget
 * @extends Component
 */
class TagWhitelistWidget extends Component {
  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    required: PropTypes.bool,
    error: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.any,
    onChange: PropTypes.func,
    wrapped: PropTypes.bool,
    vocabulary: PropTypes.object,
  };

  /**
   * Default properties
   * @property {Object} defaultProps Default properties.
   * @static
   */
  static defaultProps = {
    description: null,
    required: false,
    error: [],
    value: null,
    onChange: null,
    wrapped: true,
  };

  /**
   * Convert base64 string to array
   */
  decodeValue = (value) => {
    if (!value) return [];

    // If already an array, return it
    if (Array.isArray(value)) return value;

    // If it's a string, try to decode it
    if (typeof value === 'string') {
      try {
        // Try to decode base64
        const decoded = atob(value);
        // If decoded string contains commas, split it
        return decoded.includes(',')
          ? decoded.split(',').map((s) => s.trim())
          : [decoded];
      } catch (e) {
        // If not valid base64, treat as single value
        return [value];
      }
    }

    return [];
  };

  /**
   * Convert array to base64 string
   */
  encodeValue = (value) => {
    if (!value || value.length === 0) return null;

    // Join array values with comma and encode to base64
    const joined = value.join(',');
    return btoa(joined);
  };

  /**
   * On change handler
   */
  handleChange = (id, value) => {
    // Convert array value to base64 string before passing to parent
    const encodedValue = this.encodeValue(value);
    this.props.onChange(id, encodedValue);
  };

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    // Convert the base64 string value to array for TokenWidget
    const decodedValue = this.decodeValue(this.props.value);

    // Ensure error prop is always an array
    const { error, ...otherProps } = this.props;
    let errorArray = [];
    if (error) {
      if (Array.isArray(error)) {
        errorArray = error;
      } else if (typeof error === 'string') {
        errorArray = [error];
      } else if (typeof error === 'object' && error.message) {
        errorArray = [error.message];
      }
    }

    return (
      <TokenWidget
        {...otherProps}
        error={errorArray}
        value={decodedValue}
        onChange={this.handleChange}
      />
    );
  }
}

export default compose(injectIntl)(TagWhitelistWidget);
